<template>
    <div class="main">
        <div class="actions">
            <h3 style="font-size:28px;line-height:45px">Dashboard</h3>
        </div>
        <div>
            <div>
                <div style="">
                   
                    <a-row type="flex" justify="space-between" style="margin-top: 30px">
                        <a-col style="background: #fff;" :span="18">
                            <!-- <LineBarChart
                                    :data="chartData"
                                    categoryField="category"
                                    valueField1="value1"
                                    valueField2="value2"
                                    /> -->
                        </a-col>
                        <a-col :span="5">
                            <div
                                style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
                                <div
                                    style="background: #fff; margin-bottom: 10px; padding: 20px; border-radius: 6px; color: #05004E;">
                                    <span>Total Customers</span>
                                    <div style="display: flex; justify-content: space-between;">
                                        <div>
                                            <span style="font-size: 50px; font-weight: 500;">395</span>
                                            <!-- <a-icon type="arrow-down" :style="{ fontSize: '30px', color: 'green' }" /> -->

                                        </div>
                                        <!-- <div style="padding-top: 15px;">
                                            1100A
                                            <br>
                                            1200A
                                        </div> -->
                                    </div>
                                    <!-- <span>Quantities</span> -->
                                </div>
                                <div
                                    style="background: #fff; margin-top: 10px; padding: 20px; border-radius: 6px; color: #05004E;">
                                    <span>Top Customers </span>
                                    <div style="display: flex; justify-content: space-between;">
                                        <div>
                                            <span style="font-size: 50px; font-weight: 500;">100</span>
                                            <!-- <a-icon type="arrow-up" :style="{ fontSize: '30px', color: 'red' }" /> -->

                                        </div>
                                        <!-- <div style="padding-top: 15px;">
                                            1100A
                                            <br>
                                            1200A
                                        </div> -->
                                    </div>
                                    <!-- <span>Quantities</span> -->
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
// import _ from 'lodash';
import XLSX from "xlsx";
// import LineBarChart from './components/charts/LineBarChart.vue';

const columns = [
    //   {
    //     title: 'Thumb',
    //     // width: 80,
    //     key: 'thumb',
    //     scopedSlots: { customRender: 'thumb' },
    //   },
    {
        title: 'Product ID',
        dataIndex: 'id',
        width: 150,
    },
    {
        title: 'Product Name',
        dataIndex: 'productName',
        key: 'productName',
        width: 150,
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
        },
        // onFilter: (value, record) =>
        // record.productName
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
    },
    {
        title: 'Batch Number',
        dataIndex: 'batchNumber',
        key: 'batchNumber',
        width: 150,
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
        },
        // onFilter: (value, record) =>
        // record.productName
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
    },
    //   {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     key: 'category',
    //     width: 150,
    //     scopedSlots: {
    //     filterDropdown: 'categoryFilterDropdown',
    //     filterIcon: 'filterIcon',
    //     },
    //     // onFilter: (value, record) =>
    //     // record.category
    //     //     .toString()
    //     //     .toLowerCase()
    //     //     .includes(value.toLowerCase()),
    //     // width: 200,
    //   },
    {
        title: 'Supplier',
        dataIndex: 'supplier',
        key: 'supplier',
        width: 150,
        scopedSlots: {
            filterDropdown: 'supplierFilterDropdown',
            filterIcon: 'filterIcon',
        },
        // onFilter: (value, record) =>
        // record.supplier
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // width: 200,
    },
    //   {
    //     title: 'Manufacturer',
    //     dataIndex: 'manufacturer',
    //     key: 'manufacturer',
    //     width: 150,
    //     scopedSlots: {
    //     filterDropdown: 'manufactuereFilterDropdown',
    //     filterIcon: 'filterIcon',
    //     },
    //     // onFilter: (value, record) =>
    //     // record.supplier
    //     //     .toString()
    //     //     .toLowerCase()
    //     //     .includes(value.toLowerCase()),
    //     // width: 200,
    //   },

    {
        title: 'Quantity',
        width: 150,
        dataIndex: 'quantity',
        sorter: (a, b) => a.quantity - b.quantity,
        sortDirections: ['descend', 'ascend'],
        //  width: 150,
    },
    {
        title: 'Date Of Stock',
        width: 150,
        dataIndex: 'stockDate',
        sorter: (a, b) => a.quantity - b.quantity,
        sortDirections: ['descend', 'ascend'],
        scopedSlots: { customRender: 'stockDate' },
        //  width: 150,
    },
    {
        title: 'Date Of Out of Stock',
        width: 150,
        dataIndex: 'stockOutDate',
        sorter: (a, b) => a.quantity - b.quantity,
        sortDirections: ['descend', 'ascend'],
        scopedSlots: { customRender: 'stockOutDate' },
        //  width: 150,
    },
    //   {
    //     title: 'Commission',
    //     width: 150,
    //     dataIndex: 'commission',
    //     //  width: 150,
    //   },
    //   {
    //     title: 'Cost Price(Ksh)',
    //     key: 'costPrice',
    //     width: 150,
    //     dataIndex: 'costPrice',
    //     sorter: (a, b) => a.action.purchasePrice - b.action.purchasePrice,
    //     sortDirections: ['descend', 'ascend'],    
    //   },
    //   {
    //     title: 'Price(Ksh)',
    //     dataIndex: 'price',
    //     width: 150,
    //     sorter: (a, b) => a.action.sellingPrice - b.action.sellingPrice,
    //     sortDirections: ['descend', 'ascend'],
    //     // width: 150,
    //   },


    //  {
    //  title: 'Profit Margin',
    //  key: 'profitMargin',
    //  width: 150,
    //  dataIndex: 'profitMargin',
    // },
    //   {
    //     title: 'Status',
    //     key: 'status',
    //     width: 150,
    //     scopedSlots: { customRender: 'status' },
    //     //width: 110,
    //   },

    {
        title: 'Actions',
        key: 'actions',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'actions' },
    },
];


export default {
    name: "Dashboard",
    components: {
        // LineBarChart
    },
    data() {
        return {
            chartData: [
                { category: 'A', value1: 10, value2: 15 },
                { category: 'B', value1: 20, value2: 25 },
                { category: 'C', value1: 30, value2: 35 }
            ],
            searchText: '',
            categorySearchText: '',
            supplierSearchText: '',
            manufacturerSearchText: '',
            searchInput: null,
            categorySearchInput: null,
            supplierSearchInput: null,
            manufacturerSearchInput: null,
            searchedColumn: '',
            categorySearchedColumn: '',
            supplierSearchedColumn: '',
            manufacturerSearchedColumn: '',
            data: [],
            columns,
            product: {},
            pagination: {
                pageSize: 20,
                current: 1
            },
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {}
            },
            isListed: Boolean,
            loading: false,
            isPriceVisible: false,
            uploadImageVisible: false,
            fileList: [],
            categories: [],
            suppliers: [],
            manufacturers: [],
            inventoryWithBal: [],
            inventoryWithOutBal: [],
            balLessThan20: [],
            productId: "",
            uploading: false,
            tableLoading: false,
            exportLoading: false,
            setPrice: {
                sellingPrice: '',
                purchasePrice: ''
            },
            setPriceLoading: false,
            rules: {
                productId: [
                    { required: true, message: 'Please choose your product', trigger: 'change' },

                ],
                quantity: [
                    { required: true, message: 'Please enter your quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[1-9]\d*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                sellingPrice: [
                    { required: true, message: 'Please enter selling price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                purchasePrice: [
                    { required: true, message: 'Please enter purchase price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            }
        }
    },

    computed: {
        ...mapGetters(['getPagination']),
        sortedData() {
            // console.log("sorted | ", _.sortBy(this.data, 'createdAt'))
            // return _.orderBy(this.data, 'createdAt','desc');
            return this.data;
        }

    },
    methods: {
        ...mapActions(['finalAgentInventory', 'setCatalogInfo', 'finalAgentInventorySearchSort', 'setProductPrice', 'uploadProductImage', 'finalCategoryManufacturerSupplierList', 'setProductStatus', 'setPaginationInfo', 'setPreviewInfo']),
        handleSubmit() {
            // console.log(this.formInline);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        handleTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination before change | ", this.pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            // console.log("pagination after change | ", this.pagination);
            this.setPaginationInfo(this.pagination)
            this.tableLoading = false
        },
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.params.page = -1
            this.params.perPage = -1
            this.params.searchBy = {
                brandName: selectedKeys[0]
            }
            this.getProductsBySearSort(this.params)
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleCategorySearch(selectedKeys, confirm, dataIndex) {
            confirm();
            // console.log('selectedKeys | ', selectedKeys)
            // console.log('dataIndex | ', dataIndex)
            // this.tableLoading = true;
            this.params.page = -1
            this.params.perPage = -1
            this.params.searchBy = {
                category: selectedKeys[0]
            }
            this.getProductsBySearSort(this.params)
            // this.tableLoading = false;
            this.categorySearchText = selectedKeys[0];
            this.categorySearchedColumn = dataIndex;
        },
        handleSupplierSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.params.page = -1
            this.params.perPage = -1
            this.params.searchBy = {
                supplier: selectedKeys[0]
            }
            this.getProductsBySearSort(this.params)
            this.supplierSearchText = selectedKeys[0];
            this.supplierSearchedColumn = dataIndex;
        },
        handleManufacturerSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.params.page = -1
            this.params.perPage = -1
            this.params.searchBy = {
                manufacturer: selectedKeys[0]
            }
            this.getProductsBySearSort(this.params)
            this.manufacturerSearchText = selectedKeys[0];
            this.manufacturerSearchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
            this.params.searchBy = {
                brandName: ''
            }
            this.getProducts()
        },
        handleCategoryReset(clearFilters) {
            clearFilters();
            this.categorySearchText = ''
            this.params.searchBy = {
                category: ''
            }
            this.getProducts();
        },
        handleSupplierReset(clearFilters) {
            clearFilters();
            this.supplierSearchText = ''
            this.params.searchBy = {
                supplier: ''
            }
            this.getProducts();
        },
        handleManufacturerReset(clearFilters) {
            clearFilters();
            this.supplierSearchText = ''
            this.params.searchBy = {
                manufacturer: ''
            }
            this.getProducts();
        },
        onChange(checked) {
            this.isListed = checked;
        },
        switchStatus(checked) {
            this.tableLoading = true
            // console.log("checked | ", checked);
            // console.log("isListed | ", this.isListed);
            let request_data = {
                ProductId: checked.key,
                data: {
                    status: this.isListed
                }
            }
            // console.log("request_data | ", request_data);
            this.setProductStatus(request_data).then(response => {
                this.tableLoading = false
                if (response.status === 200) {
                    this.getProducts()
                    if (this.isListed) {
                        this.showSuccessAlert(`Product [ ${checked.productName} ] Enabled Successfully`)
                    } else {
                        this.showSuccessAlert(`Product [ ${checked.productName} ] Disabled Successfully`)
                    }
                } else {
                    this.showErrorAlert(response.data.messages)
                }
            }, error => {
                this.tableLoading = false;
                console.log('Error | ', error)
            })
        },
        showAddProductPage() {
            this.$router.push('/new-product').catch(() => { });
        },
        showAddStockPage() {
            this.$router.push('/add-stock').catch(() => { });
        },

        showMoreDetailsModal(data) {
            // console.log("data | ",data)
            this.setCatalogInfo(data.action);
            this.$router.push('/catalog-details').catch(() => { });
        },
        showPriceModal(data) {
            this.setPrice.sellingPrice = data.action.sellingPrice
            this.setPrice.purchasePrice = data.action.purchasePrice
            this.isPriceVisible = true
            this.product = data
        },
        showUploadImage(data) {
            // console.log("data | ",data)
            this.productId = data.key
            this.uploadImageVisible = true
        },
        handleSetPriceCancel() {
            this.isPriceVisible = false
        },
        handleUploadImgCancel() {
            this.uploadImageVisible = false
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        exportExcell() {
            this.exportLoading = true
            const dataToExport = [
                [
                    "Product ID",
                    "Product Name",
                    "Category",
                    "Supplier",
                    "Manufacturer",
                    "Quantity",
                    "Commission",
                    "Cost Price(Ksh)",
                    "Selling Price",
                    "Profit Margin"
                ],
            ];

            this.data.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.productName,
                    v.category,
                    v.supplier,
                    v.manufacturer,
                    v.quantity,
                    v.commission,
                    v.costPrice,
                    v.price,
                    v.profitMargin
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Product-Catalog-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")

        },
        handleAddPriceSubmit() {
            this.$refs.setPriceForm.validate(valid => {
                if (valid) {
                    this.setPriceLoading = true
                    // console.log("setPrice | ", this.setPrice)
                    // console.log("product | ", this.product)

                    let request_data = {
                        sellingPrice: parseInt(this.setPrice.sellingPrice),
                        purchasePrice: parseInt(this.setPrice.purchasePrice),
                        status: null
                    }

                    let finalRequestData = {
                        ProductId: this.product.key,
                        request_data: request_data
                    }

                    // console.log("request_data | ", request_data)
                    this.setProductPrice(finalRequestData).then(response => {

                        this.setPriceLoading = false;
                        this.isPriceVisible = false
                        if (response.status === 200) {
                            this.getProducts();
                            this.showSuccessAlert("Product Price Set Successfully")
                            this.$refs.setPriceForm.resetFields();
                        } else {
                            this.showErrorAlert(response.data.messages)
                        }
                    },
                        error => {
                            this.setPriceLoading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })
                } else {
                    // console.log('error submit!!');
                    this.setPriceLoading = false;
                    return false;
                }
            });
        },
        showConfirm(data) {
            this.$confirm({
                title: `Delete Product?`,
                content: `Do you want to delete this product, ${data.title} ?`,
                onOk() {
                    return new Promise((resolve, reject) => {
                        setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                    }).catch(() => console.log('Oops errors!'));
                },
                onCancel() { },
            });
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            // console.log("file type | ", file.type)
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.fileList = [];
                this.showErrorAlert("You can only upload PNG or JPEG file!")
                // console.log("fileList not png | ", this.fileList)
                return false;
            } else {
                // console.log("fileList png | ", this.fileList)
                this.fileList = [...this.fileList, file];
                return false;
            }
        },
        handleUpload() {
            const { fileList } = this;
            const formData = new FormData();
            fileList.forEach(file => {
                formData.append('Image', file);
            });
            this.uploading = true;
            let request_data = {
                ProductId: this.productId,
                formData: formData
            }

            this.uploadProductImage(request_data).then(response => {
                // console.log("response image | ", response)
                this.uploadImageVisible = false
                this.fileList = [];
                this.uploading = false;
                if (response.status === 200) {
                    this.getProducts();
                    this.showSuccessAlert("Product Image Uploaded Successfully")
                } else {
                    this.showErrorAlert(response.data.messages)
                }
            },
                error => {
                    this.uploading = false;
                    this.showErrorAlert(JSON.stringify(error))
                })
        },
        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },
        showOutOfStockPage() {
            let distributionData = this.inventoryWithOutBal.map(product => ({
                key: this.randomString(10),
                id: product.key,
                name: product.productName ? product.productName : "N/A",
                category: product.category ? product.category : "N/A",
                quantity: product.quantity ? product.quantity.toString() : '0',
                unitPrice: product.costPrice ? product.costPrice.toString() : "0",
                lineTotal: parseInt(product.quantity) * parseInt(product.costPrice),
                extra_data: product.action

            }))

            let previewData = {
                discount: '',
                deliveryDate: "",
                supplierName: "",
                supplierId: "",
                distributionCentreName: '',
                distributionCentreId: '',
                supplierAddress: '',
                supplierCity: '',
                supplierCountry: '',
                destionation: '',
                shipAddress: '',
                shipCity: '',
                shipCountry: '',
                shippingMethod: '',
                shippinTerm: '',
                originalData: distributionData,
                tableData: distributionData
            }
            // console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/quick-action-receipt').catch(() => { });
        },
        showLowStockPage() {
            let distributionData = this.balLessThan20.map(product => ({
                key: this.randomString(10),
                id: product.key,
                name: product.productName ? product.productName : "N/A",
                category: product.category ? product.category : "N/A",
                quantity: product.quantity ? product.quantity.toString() : '0',
                unitPrice: product.costPrice ? product.costPrice.toString() : "0",
                lineTotal: parseInt(product.quantity) * parseInt(product.costPrice),
                extra_data: product.action
            }))

            let previewData = {
                discount: '',
                deliveryDate: "",
                supplierName: "",
                supplierId: "",
                distributionCentreName: '',
                distributionCentreId: '',
                supplierAddress: '',
                supplierCity: '',
                supplierCountry: '',
                destionation: '',
                shipAddress: '',
                shipCity: '',
                shipCountry: '',
                shippingMethod: '',
                shippinTerm: '',
                originalData: distributionData,
                tableData: distributionData
            }
            //   console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/quick-action-receipt').catch(() => { });
        },
        getProducts() {
            this.tableLoading = true
            this.params.page = -1
            this.params.perPage = -1
            // console.log("initial data in getProducts | ", this.params)
            this.finalAgentInventory(this.params).then(response => {
                this.tableLoading = false;
                // console.log('response products ', response)
                let finalAgentInventory = [];
                if (response[0].status !== 200 && response[1].status !== 200) {
                    this.showErrorAlert(response.data.messages)
                } else if (response[0].status === 200 && response[1].status === 200) {
                    let productsResponse = response[0].data.data
                    let inventoryResponse = response[1].data.data
                    let inventoryWithBal = [];
                    let inventoryWithOutBal = [];

                    let inventoryIds = inventoryResponse.map(inventory => inventory.productId);

                    for (var product of productsResponse) {
                        for (var inventory of inventoryResponse) {
                            if (product.id === inventory.productId) {
                                // console.log("product | ", product)
                                let agentInventory = {}
                                agentInventory['key'] = product.id

                                agentInventory['id'] = product.id
                                agentInventory['category'] = product.categoryName
                                agentInventory['supplier'] = product.supplierName
                                agentInventory['manufacturer'] = product.manufacturerName
                                agentInventory['productName'] = product.brandName
                                agentInventory['commission'] = product.commission,
                                    agentInventory['quantity'] = inventory.balance
                                agentInventory['createdAt'] = moment(product.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                                agentInventory['price'] = product.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                agentInventory['status'] = product.isActive === true ? product.isActive : false
                                agentInventory['costPrice'] = product.purchasePrice ? product.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'N/A'
                                agentInventory['profitMargin'] = `${product.margin.toFixed(2)}%`
                                agentInventory['action'] = product

                                inventoryWithBal.push(agentInventory)
                            }
                        }
                    }

                    for (var product2 of productsResponse) {
                        if (!inventoryIds.includes(product2.id)) {
                            // console.log("product | ", product)
                            let agentInventory = {}
                            agentInventory['key'] = product2.id
                            agentInventory['id'] = product2.id
                            agentInventory['category'] = product2.categoryName
                            agentInventory['productName'] = product2.brandName
                            agentInventory['supplier'] = product2.supplierName
                            agentInventory['manufacturer'] = product2.manufacturerName
                            agentInventory['commission'] = product2.commission,
                                agentInventory['quantity'] = 0
                            agentInventory['createdAt'] = moment(product2.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                            agentInventory['price'] = product2.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })
                            agentInventory['status'] = product2.isActive === true ? product2.isActive : false
                            agentInventory['costPrice'] = product2.purchasePrice ? product2.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'N/A'
                            agentInventory['profitMargin'] = `${product2.margin.toFixed(2)}%`
                            agentInventory['action'] = product2

                            inventoryWithOutBal.push(agentInventory)
                        }
                    }

                    inventoryWithBal.forEach(product => {
                        finalAgentInventory.push(product)
                    })

                    this.inventoryWithBal = inventoryWithBal

                    inventoryWithOutBal.forEach(product => {
                        finalAgentInventory.push(product)
                    })

                    this.inventoryWithOutBal = inventoryWithOutBal

                    let lowStockProducts = this.inventoryWithBal.concat(this.inventoryWithOutBal)
                    this.balLessThan20 = lowStockProducts.filter(inventory => inventory.quantity < 20)
                } else {
                    console.log('Error | ', response)
                    this.showErrorAlert('Something went wrong, try again later.')
                }

                this.data = finalAgentInventory
                // console.log("data  | ", this.data)
                const pager = { ...this.pagination };
                pager.current = this.getPagination.current;
                this.pagination = pager;
                // console.log("pagination in getProducts | ", this.pagination)
                // this.data = finalAgentInventory
            },
                error => {
                    console.log('Error | ', error)
                })
        },
        getProductsBySearSort(request_data) {
            this.tableLoading = true

            // console.log("request_data in getProductsBySearSort | ", request_data)
            this.finalAgentInventorySearchSort(request_data).then(response => {
                this.tableLoading = false;
                // console.log('response products ', response)
                let finalAgentInventory = [];
                if (response[0].status !== 200 && response[1].status !== 200) {
                    this.showErrorAlert(response.data.messages)
                } else if (response[0].status === 200 && response[1].status === 200) {
                    let productsResponse = response[0].data.data
                    let inventoryResponse = response[1].data.data
                    let inventoryWithBal = [];
                    let inventoryWithOutBal = [];

                    let inventoryIds = inventoryResponse.map(inventory => inventory.productId);

                    for (var product of productsResponse) {
                        for (var inventory of inventoryResponse) {
                            if (product.id === inventory.productId) {
                                // console.log("product | ", product)
                                let agentInventory = {}
                                agentInventory['key'] = product.id
                                agentInventory['id'] = product.id
                                agentInventory['category'] = product.categoryName
                                agentInventory['supplier'] = product.supplierName
                                agentInventory['manufacturer'] = product.manufacturerName
                                agentInventory['productName'] = product.brandName
                                agentInventory['commission'] = product.commission,
                                    agentInventory['quantity'] = inventory.balance
                                agentInventory['createdAt'] = moment(product.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                                agentInventory['price'] = product.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                agentInventory['status'] = product.isActive === true ? product.isActive : false
                                agentInventory['costPrice'] = product.purchasePrice ? product.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'N/A'
                                agentInventory['profitMargin'] = `${product.margin.toFixed(2)}%`
                                agentInventory['action'] = product

                                inventoryWithBal.push(agentInventory)
                            }
                        }
                    }

                    for (var product2 of productsResponse) {
                        if (!inventoryIds.includes(product2.id)) {
                            // console.log("product | ", product)
                            let agentInventory = {}
                            agentInventory['key'] = product2.id
                            agentInventory['id'] = product.id
                            agentInventory['category'] = product2.categoryName
                            agentInventory['productName'] = product2.brandName
                            agentInventory['supplier'] = product2.supplierName
                            agentInventory['manufacturer'] = product2.manufacturerName
                            agentInventory['commission'] = product2.commission,
                                agentInventory['quantity'] = 0
                            agentInventory['createdAt'] = moment(product2.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                            agentInventory['price'] = product2.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })
                            agentInventory['status'] = product2.isActive === true ? product2.isActive : false
                            agentInventory['costPrice'] = product2.purchasePrice ? product2.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'N/A'
                            agentInventory['profitMargin'] = `${product2.margin.toFixed(2)}%`
                            agentInventory['action'] = product2

                            inventoryWithOutBal.push(agentInventory)
                        }
                    }

                    inventoryWithBal.forEach(product => {
                        finalAgentInventory.push(product)
                    })

                    inventoryWithOutBal.forEach(product => {
                        finalAgentInventory.push(product)
                    })

                } else {
                    console.log('Error | ', response)
                    this.showErrorAlert('Something went wrong, try again later.')
                }

                this.data = finalAgentInventory
                // console.log("data | ", this.data)
                // console.log("getPagination  | ", this.getPagination)
                const pager = { ...this.pagination };
                pager.current = this.getPagination.current;
                this.pagination = pager;
                // console.log("pagination in getProducts | ", this.pagination)
                // this.data = finalAgentInventory
            },
                error => {
                    console.log('Error | ', error)
                })
        }
    },
    created() {
        if (this.getProducts()) {
            this.getProducts()
        }
        this.finalCategoryManufacturerSupplierList().then(response => {

            this.manufacturers = response[0].data.data
            this.categories = response[1].data.data
            this.suppliers = response[2].data.data
        },
            error => {
                console.log("error | ", error)
            })
    },
}
</script>

<style scoped>
.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.actions {
    display: flex;
    justify-content: space-between;
}


.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
    width: 100%
}


.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;

}

.ant-form-item {
    font-size: 14px;
    height: 38px;
    width: 294px;
    border-radius: 5px;
}

.ant-form-item>>>span {
    text-align: center;
}

.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

button:hover {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.orderTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.numberInput {
    width: 100%;
    border-radius: 5px;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}


.orderTable>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: none;
    padding: 0px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>